import React from "react";
import "./typography/style/style.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import LoginForm from "./Components/Login/Login";
import ManageCustomer from "./Components/Customer/ManageCustomer";
import EBasicDetails from "./Components/Customer/eBasicDetails";
import BasicDetails from "./Components/Customer/CBasicDetails";
import EBillingDetail from "./Components/Customer/eBillingDetail";
import BillingDetail from "./Components/Customer/CBillingDetail";
import EBranding from "./Components/Customer/eBranding";
import Branding from "./Components/Customer/CBranding";
import AddQuestions from "./Components/Profiling/AddQuestions";
import EditQuestions from "./Components/Profiling/EditQuestions";
import AddPanelUser from "./Components/Profiling/AddPanelUser";
import EditPanelUser from "./Components/Profiling/EditPanelUser";
import ProfilingQuestions from "./Components/Profiling/ProfilingQuestions";
import Dashboard from "./Components/Dashborad/Dashboard";
import Atest from "./Components/Mains/Atest";
import AddQuota from "./Components/Survey/AddQuota";
import EditQuota from "./Components/Survey/EditQuota";

import Setting from "./Components/Customer/Setting";
import Subscription from "./Components/Superadmin/Subscription1";
import UserManagement from "./Components/Users/UserManagement";
import AddUser from "./Components/Users/AddUser";
import EditUser from "./Components/Users/EditUser";
import Invoice from "./Components/Superadmin/Invoice";
import Plans from "./Components/Mains/Plans";
import PanelManagement from "./Components/Profiling/PanelManagement";
import ManageProfilingQuestions from "./Components/Profiling/ManageProfilingQuestions";
import PrivateRoute from "./Components/Context/PrivateRoute";
import AuthProvider from "./Components/Context/AuthProvider";
import Reduxtest from "../src/redux/reduxtest";
import ErrorBoundary from "./Components/Mains/ErrorBoundary";
import SuperAdmin from "./Components/Superadmin/SuperAdmin";
import SurveyForm from "./Components/Survey/SurveyForm";
import SurveyListing from "./Components/Survey/SurveyListing";
import ESurveyForm from "./Components/Survey/eSurveyForm";
import SurveyProgramming from "./Components/Survey/SurveyProgramming";
import Alerts from "./Components/Mains/Alerts";
import QuotaView from "./Components/Survey/QuotaView";
import ConnectClientDatabase from "./Components/Profiling/ConnectClientDatabase";
import DemoQuestions from "./Components/Survey/DemoQuestions";
// import SurveyProg from "./Components/Mains/SurveyProg";
import "./App.css";
import "./Components/Mains/Atest.css";


function App() {
  return (
    <div className="App">
      <Router basename="/">
        <AuthProvider>
          {/* <ErrorBoundary> */}
          <Routes>
            <Route path="/" element={<LoginForm />} />
            <Route
              path="/resetpassword"
              element={<LoginForm showModalOnLoad />}
            />
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/manage-customer" element={<ManageCustomer />} />
              <Route path="/basic-detail" element={<BasicDetails />} />
              <Route path="/ebasic-detail" element={<EBasicDetails />} />
              <Route path="/billing-detail" element={<BillingDetail />} />
              <Route path="/ebilling-detail" element={<EBillingDetail />} />
              <Route path="/branding" element={<Branding />} />
              <Route path="/ebranding" element={<EBranding />} />
              <Route path="/addquestions" element={<AddQuestions />} />
              <Route path="/edit-questions" element={<EditQuestions />} />
              <Route path="/addpaneluser" element={<AddPanelUser />} />
              <Route path="/editpaneluser" element={<EditPanelUser />} />
              <Route
                path="/profiling-questions"
                element={<ProfilingQuestions />}
              />
              <Route path="/atest" element={<Atest />} />

              <Route path="/add-quota" element={<AddQuota />} />
              <Route path="/setting" element={<Setting />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/user-management" element={<UserManagement />} />
              <Route path="/add-user" element={<AddUser />} />
              <Route path="/edit-user" element={<EditUser />} />
              <Route path="/invoice" element={<Invoice />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/panel-management" element={<PanelManagement />} />
              <Route
                path="/manage-profiling-questions"
                element={<ManageProfilingQuestions />}
              />
              <Route path="/view-quota" element={<QuotaView />} />
              <Route path="/surveyprog" element={<SurveyProgramming />} />
              <Route path="/reduxtest" element={<Reduxtest />} />
              <Route path="/superadmin" element={<SuperAdmin />} />
              <Route path="/survey-form" element={<SurveyForm />} />
              <Route path="/esurvey-form" element={<ESurveyForm />} />
              <Route path="/survey-listing" element={<SurveyListing />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/survey-programming" element={<SurveyProgramming />} />
              <Route path="/connect-client-database" element={<ConnectClientDatabase />} />\
              <Route path="/edit-quota" element={<EditQuota />} />

              <Route path="/demo-questions" element={<DemoQuestions />} />

            </Route>
          </Routes>
          {/* </ErrorBoundary> */}
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
